export default __webpack_public_path__ + "static/media/Hero Image-min.8578ec4b.png";